// src/pages/Twplanners/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getTwPlanners, PRODUCTS_PER_PAGE } from "../data/twPlanners";

export default function Twplanners() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getTwPlanners()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/twplanner",
    announcement: {
      headline: "Get 20% Off the new 2026 Planners!",
      subtext: "Plan your best year yet • 300+ designs to personalise",
    },
    hero: {
      title: "2026 Planners",
      subtitle: "Your best year, beautifully planned",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "Best planner I've ever used — the dated layout keeps me on track every single day.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "1000+",
    },
  };

  return <CollectionPage config={config} />;
}